// ../../react-shim.js
import React from "react";

// src/index.ts
import { css, keyframes } from "@emotion/css";

// src/jsx.tsx
import { jsx as emotion } from "@emotion/react";
var jsx = (props, type = "div", ...children) => {
  if (props.as) {
    type = props.as;
  }
  return emotion.apply(type, [type, props, ...children]);
};

// src/system.tsx
import clsx from "clsx";

// ../utils/dist/index.esm.js
import React2 from "react";
import React22 from "react";
var isFunction = (value) => {
  return typeof value === "function";
};
var isArray = (value) => {
  return Array.isArray(value);
};
var isUndefined = (value) => typeof value === "undefined" || value === void 0;
var isObject = (value) => {
  const type = typeof value;
  return value !== null && (type === "object" || type === "function") && !isArray(value);
};
var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;
var isString = (value) => Object.prototype.toString.call(value) === "[object String]";
var __DEV__ = process.env.NODE_ENV !== "production";
var _window;
try {
  _window = window;
} catch {
}
var getWindow = (node) => {
  var _a;
  return ((_a = node == null ? void 0 : node.ownerDocument) == null ? void 0 : _a.defaultView) ?? _window;
};
var checkIsBrowser = () => {
  const __window = getWindow();
  return Boolean(
    typeof __window !== "undefined" && __window.document && __window.document.createElement
  );
};
var isBrowser = checkIsBrowser();
var SELECTORS = [
  "input",
  "select",
  "textarea",
  "a[href]",
  "area[href]",
  "button",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]:not([contenteditable=false])"
];
var selector = SELECTORS.join();
var runIfFn = (valueOrFn, ...args) => {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
};
var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;

// src/create-component.tsx
import hoist from "hoist-non-react-statics";
import React4 from "react";

// src/system.utils.ts
import React3 from "react";
var domElements = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "button",
  "caption",
  "cite",
  "circle",
  "code",
  "col",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hr",
  "i",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "nav",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "path",
  "picture",
  "pre",
  "q",
  "rect",
  "s",
  "svg",
  "section",
  "select",
  "small",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "u",
  "ul",
  "video"
];
var isTag = (target) => {
  return isString(target) && __DEV__ ? target.charAt(0) === target.charAt(0).toLowerCase() : true;
};
var getComponentName = (primitive) => {
  return (__DEV__ ? isString(primitive) && primitive : false) || !isString(primitive) && primitive.displayName || !isString(primitive) && primitive.name || "NatureComponent";
};
var getDisplayName = (primitive) => {
  return isTag(primitive) ? `nature.${primitive}` : getComponentName(primitive);
};
var forwardRef = (comp) => {
  return React3.forwardRef(comp);
};

// src/create-component.tsx
var createComponent = (component) => {
  return (...interpolations) => {
    const Component = React4.forwardRef((_props, ref) => {
      const { as, ...props } = _props;
      let computedStyles = {};
      interpolations.forEach((interpolation) => {
        const style = runIfFn(interpolation, { ...props });
        computedStyles = {
          ...computedStyles,
          ...style
        };
      });
      const element = as || component;
      const isTag2 = isString(element);
      const computedProps = isTag2 ? { ...props } : { ...props };
      if (computedProps.className && typeof computedProps.className === "string" && computedProps.className.length) {
        computedProps.className = computedProps.className;
      }
      if (isEmptyObject(computedProps.css) || isUndefined(computedProps.css)) {
        delete computedProps.css;
      }
      return jsx(
        {
          ref,
          ...computedProps
        },
        element
      );
    });
    Component.displayName = getDisplayName(component);
    Component.defaultProps = component.defaultProps;
    const MainComponent = hoist(Component, component);
    return MainComponent;
  };
};

// src/system.tsx
var natureComp = (component) => {
  return createComponent(component)();
};
var nature = natureComp;
domElements.forEach((tag) => {
  nature[tag] = nature(tag);
});
export {
  clsx,
  css,
  domElements,
  forwardRef,
  getComponentName,
  getDisplayName,
  isTag,
  jsx,
  keyframes,
  nature,
  natureComp
};
